module.exports = function getResource (label, vars = []) {
    let resources = {
        month: 'Mois',
        day: 'Jour',
        year: 'Année'
    };
    return resources[label];
};
